module.exports = __webpack_public_path__ + "img/logo-presse-tandance-ouest_200x200.dee94e5e.jpg";